<template>
	<svg
		:width="iconSize"
		:height="iconSize"
		viewBox="0 0 25 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M11.2734 2.25C15.9808 2.25 19.7969 6.06607 19.7969 10.7734C19.7969 12.8567 19.0468 14.7648 17.8057 16.2451L22.6865 21.126L22.7383 21.1826C22.9786 21.4772 22.9611 21.9119 22.6865 22.1865C22.4119 22.4611 21.9772 22.4786 21.6826 22.2383L21.626 22.1865L16.7451 17.3057C15.2648 18.5468 13.3567 19.2969 11.2734 19.2969C6.56607 19.2969 2.75 15.4808 2.75 10.7734C2.75 6.06607 6.56607 2.25 11.2734 2.25ZM7.45605 7.36914C7.08775 7.36914 6.78906 7.66783 6.78906 8.03613V16.1787C8.00558 17.1891 9.56846 17.7969 11.2734 17.7969C12.8561 17.7969 14.3156 17.2738 15.4902 16.3906V8.03613C15.4902 7.66783 15.1915 7.36914 14.8232 7.36914H7.45605ZM8.87793 13.9873C9.19088 13.9873 9.44522 14.2408 9.44531 14.5537V14.5596C9.44531 14.8726 9.19093 15.126 8.87793 15.126H8.87207C8.55923 15.1258 8.30567 14.8725 8.30566 14.5596V14.5537C8.30576 14.2409 8.55928 13.9875 8.87207 13.9873H8.87793ZM13.4062 13.9873C13.7192 13.9873 13.9735 14.2408 13.9736 14.5537C13.9736 14.8667 13.7193 15.1211 13.4062 15.1211H10.5723C10.2594 15.1209 10.0059 14.8666 10.0059 14.5537C10.006 14.2409 10.2595 13.9875 10.5723 13.9873H13.4062ZM11.2734 3.75C7.3945 3.75 4.25 6.8945 4.25 10.7734C4.25 12.1213 4.63081 13.3798 5.28906 14.4492V8.03613C5.28906 6.8394 6.25932 5.86914 7.45605 5.86914H14.8232C16.02 5.86914 16.9902 6.8394 16.9902 8.03613V14.8516C17.8122 13.7014 18.2969 12.2948 18.2969 10.7734C18.2969 6.8945 15.1524 3.75 11.2734 3.75ZM8.87793 11.7197C9.19094 11.7197 9.44531 11.9741 9.44531 12.2871V12.293C9.44509 12.6058 9.1908 12.8594 8.87793 12.8594H8.87207C8.55936 12.8592 8.30589 12.6057 8.30566 12.293V12.2871C8.30566 11.9742 8.55922 11.7199 8.87207 11.7197H8.87793ZM13.4062 11.7197C13.7193 11.7197 13.9736 11.9741 13.9736 12.2871C13.9735 12.6 13.7192 12.8535 13.4062 12.8535H10.5723C10.2595 12.8533 10.006 12.5999 10.0059 12.2871C10.0059 11.9742 10.2594 11.7199 10.5723 11.7197H13.4062ZM8.87793 9.45312C9.19082 9.45312 9.44513 9.70668 9.44531 10.0195V10.0254C9.44531 10.3384 9.19094 10.5928 8.87793 10.5928H8.87207C8.55922 10.5926 8.30566 10.3383 8.30566 10.0254V10.0195C8.30585 9.7068 8.55934 9.45331 8.87207 9.45312H8.87793ZM13.4062 9.45312C13.7191 9.45312 13.9734 9.70668 13.9736 10.0195C13.9736 10.3325 13.7193 10.5869 13.4062 10.5869H10.5723C10.2594 10.5867 10.0059 10.3324 10.0059 10.0195C10.006 9.70682 10.2596 9.45334 10.5723 9.45312H13.4062Z"
			:fill="color"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconSvgLegislative',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
